import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import styles from './styles.module.scss';

type Props = Omit<BaseButtonProps, 'icon'> & {
    icon?: React.ReactNode;
};

export const ChangeRegionButton = ({ children, icon, ...props }: Props) => {
    return (
        <BaseButton {...props} className={styles['change-region-button']}>
            {icon && <span className={styles['change-region-button__icon']}>{icon}</span>}
            {children ? children : null}
        </BaseButton>
    );
};
